import React, { useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import iconClose from '../../../assets/imgs/landing-page/icon_close.svg';
import './services.css';
import DOMPurify from 'dompurify';

const sanitizeImageUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  const isSafeProtocol = /^(https?:\/\/|\/|\.\/)/i.test(trimmed);
  const isDangerous = /^(javascript|data|vbscript):/i.test(trimmed);

  if (isSafeProtocol && !isDangerous) {
    return DOMPurify.sanitize(trimmed);
  }
  return '';
};

const ContentDisplay = ({ content }) => {
  const { quill, quillRef } = useQuill({
    readOnly: true,
    modules: { toolbar: false }
  });

  useEffect(() => {
    if (quill) {
      // Limpia el editor y carga el contenido desde JSON.
      const parsedContent = typeof content === 'string' ? JSON.parse(content) : content;
      quill.setContents(parsedContent);
    }
  }, [quill, content]);

  return (
    <div>
      <div ref={quillRef} style={{ border: 'none' }} />
    </div>
  );
};

const InternationalModal = ({ isOpen, onClose, cardData, apiData }) => {
  if (!isOpen) return null;

  const safeBannerUrl = cardData ? sanitizeImageUrl(cardData.banner) : '';
  const safeTitle = cardData?.title ? DOMPurify.sanitize(cardData.title) : '';
  const safeView = apiData?.view ? DOMPurify.sanitize(apiData.view).toUpperCase() : '';
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>
          <img src={iconClose} alt="Cerrar" className="close-icon" />
        </button>
        <div className='modal-scrollable-content'>
          {safeBannerUrl && (
            <img src={safeBannerUrl} alt={safeTitle} className="modal-image" />
          )}
          <div className="modal-text-content">
           <h2>INTERNACIONALES / <span>{safeView}</span></h2>
            {apiData?.text_es?.["01-descripción"]?.content && (
              <ContentDisplay content={apiData.text_es["01-descripción"].content} />
            )}
            {/* <p>Express es nuestra solución para envíos urgentes. Con Express, garantizamos que sus envíos urgentes despeguen y se encuentren volando rápidamente a más de 900 destinos en 175 países.</p>
              <h5>CARACTERÍSTICAS Y BENEFICIOS</h5>
              <ul>
                <li>Máxima prioridad de embarque.</li>
                <li>Entrega anticipada después de la llegada.</li>
                <li>Asignación de vuelo al momento de la documentación.</li>
                <li>Aplica sólo en mercancía general.</li>
              </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternationalModal;